import { useRegisterSW } from "virtual:pwa-register/react";

const REVISAR_CADA_MS = 60 * 60 * 1000; // 1 hora

/**
 * Antes, el service worker se registraba con el script mínimo que
 * vite-plugin-pwa auto-inyecta (solo `navigator.serviceWorker.register(...)`,
 * sin lógica de detectar-y-recargar) — así que aunque se publicara una
 * versión nueva, una pestaña ya abierta seguía corriendo el JS viejo hasta
 * que algo forzaba una recarga completa (cerrar sesión, o un chunk viejo
 * dando 404 atrapado por ErrorBoundaryApp). El cambio nunca se "reflejaba"
 * solo, por más que el archivo ya estuviera actualizado en el servidor.
 *
 * Este componente reemplaza ese script: registra el service worker con el
 * hook oficial, revisa activamente si hay una versión nueva (al registrar y
 * cada hora mientras la pestaña sigue abierta) y muestra un aviso claro con
 * un botón para aplicarla cuando el usuario quiera — en vez de silencio.
 */
export default function ActualizacionPwaWatcher() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      setInterval(() => {
        registration.update().catch(() => {
          // Sin conexión o el servidor no respondió: se reintenta en el próximo ciclo.
        });
      }, REVISAR_CADA_MS);
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-4 left-1/2 z-[999] flex -translate-x-1/2 items-center gap-3 rounded-2xl border border-magenta/30 bg-white px-4 py-3 shadow-xl animate-in fade-in slide-in-from-bottom-4">
      <span className="text-lg">🔄</span>
      <p className="text-xs font-bold text-texto">Hay una actualización de la app disponible</p>
      <button
        onClick={() => updateServiceWorker(true)}
        className="whitespace-nowrap rounded-full bg-magenta px-3 py-1.5 text-xs font-black text-white transition hover:scale-105 active:scale-95"
      >
        Actualizar ahora
      </button>
    </div>
  );
}
